import CHAT_PUBLIC_FIELDS from './ChatPublicFields';
import CHAT_MESSAGE_FIELDS from './MessageFields';

export default Object.values({ CHAT_PUBLIC_FIELDS, CHAT_MESSAGE_FIELDS });
export { CHAT_PUBLIC_FIELDS, CHAT_MESSAGE_FIELDS };
